import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const COLS = [
  { title: 'Listen', links: [
    { t: 'Music Reel', h: '/feed' },
    { t: 'Artists', h: '/artists' },
    { t: 'Radio', h: '/reapercast' },
    { t: 'Knowledge Hub', h: '/hub' },
    { t: 'My Profile', h: '/listener' },
  ] },
  { title: 'For artists', links: [
    { t: 'Music Biz Academy', h: '/academy' },
    { t: 'Income Tool', h: '/income' },
    { t: 'Upload tracks', h: '/reapercast' },
    { t: 'Research Vault', h: '/research' },
    { t: 'Migration Center', h: '/migrate' },
    { t: 'Beta Program', h: '/beta' },
  ] },
  { title: 'VidCreForge', links: [
    { t: 'Upload video', h: '/upload' },
    { t: 'Creator Studio', h: '/studio' },
    { t: 'Explore', h: '/home' },
    { t: 'Shorts', h: '/shorts' },
    { t: 'Memberships', h: '/memberships' },
  ] },
  { title: 'Legal', links: [
    { t: 'Terms of Service', h: '/legal/terms' },
    { t: 'Privacy Policy', h: '/legal/privacy' },
    { t: 'DMCA', h: '/legal/dmca' },
    { t: 'Disclosures', h: '/legal/disclosures' },
    { t: 'Changelog', h: '/changelog' },
  ] },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-16 bg-[#07070a]" data-testid="global-footer">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2 md:col-span-1">
          <Logo />
          <p className="text-white/55 text-[12.5px] leading-relaxed mt-3">
            The operating system for independent music. Academy + AI specialists + radio + knowledge hub + video hosting (VidCreForge) — bundled free for every artist.
          </p>
        </div>
        {COLS.map(col => (
          <div key={col.title}>
            <div className="text-[11px] uppercase tracking-wider text-white/45 font-bold mb-3">{col.title}</div>
            <ul className="space-y-2">
              {col.links.map(l => (
                <li key={l.t}>
                  <Link to={l.h} className="text-[13.5px] text-white/75 hover:text-[#ff6b8a]" data-testid={`footer-link-${l.h.replace(/\//g,'-').replace(/^-/,'')}`}>{l.t}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-[12px] text-white/45">
          <div>© {new Date().getFullYear()} ReaperCast. VidCreForge is a ReaperCast product.</div>
          <div className="flex items-center gap-4">
            <Link to="/legal/terms" className="hover:text-white/80">Terms</Link>
            <Link to="/legal/privacy" className="hover:text-white/80">Privacy</Link>
            <Link to="/legal/dmca" className="hover:text-white/80">DMCA</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
